import React, { useState } from "react";
import { Box, Skeleton } from "@mui/material";
import styles from "./styles";

const ImageGallery = ({ projectFiles }) => {
  const [showAll, setShowAll] = useState(false);
  const images = projectFiles?.supportingImages || [];
  const visibleImages = showAll ? images : images.slice(0, 6);
  const hiddenCount = images.length - 6;

  return (
    <div style={{ ...styles.columnFlex, gap: "15px", marginTop: "2vh" }}>
      <div style={styles.section_heading}>Supporting Images</div>

      <Box display="flex" gap={2} flexWrap="wrap">
        {projectFiles?.loading ? (
          <Skeleton variant="rectangular" width={100} height={100} />
        ) : images.length > 0 ? (
          visibleImages.map((image, index) => (
            <Box key={image?.path} position="relative">
              <img
                src={image?.path}
                alt={`supporting-img-${index}`}
                height={120}
                width={120}
                style={{ objectFit: "cover", borderRadius: "4px" }}
              />
              {index === 5 && !showAll && hiddenCount > 0 && (
                <Box
                  position="absolute"
                  top={0}
                  left={0}
                  width="100%"
                  height="100%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  bgcolor="rgba(0,0,0,0.5)"
                  color="white"
                  fontSize="18px"
                  fontWeight="bold"
                  borderRadius="4px"
                  onClick={() => setShowAll(true)}
                  style={{ cursor: "pointer" }}
                >
                  +{hiddenCount} more
                </Box>
              )}
            </Box>
          ))
        ) : (
          <p style={{ ...styles.modal_value, fontWeight: "400" }}>
            No Images Found
          </p>
        )}
      </Box>
    </div>
  );
};

export default ImageGallery;
